<template>
  <v-row dense class="mt-1">
    <v-col cols="12">
      <v-row dense align="center">
        <v-col cols="auto">
          <span class="text-h6">
            {{ $t('header') }}
          </span>
        </v-col>
        <v-col cols="auto">
          <Icon
            icon="mdi-information-outline"
            iconColor="info"
            :tooltipText="$t('scaleSheetProfileHeaderTooltip')"
            :small="false"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.skipTop"
        :rules="[rules.positiveInteger, rules.positiveIntegerBetweenOrBlank(0, constants.MAX_LINE_LENGTH)]"
        :label="$t('skipTop')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.skipBottom"
        :rules="[rules.positiveInteger, rules.positiveIntegerBetweenOrBlank(0, constants.MAX_LINE_LENGTH)]"
        :label="$t('skipBottom')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.skipBottomExpanded"
        :rules="[rules.positiveIntegerBetweenOrBlank(0, constants.MAX_LINE_LENGTH)]"
        :label="$t('skipBottomExpanded')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.readUntil"
        :rules="[rules.required]"
        :label="$t('readUntil')"
        outlined
        maxLength="32"
        counter="32"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.ticketNumberLine"
        :rules="[rules.required, rules.positiveIntegerBetweenOrBlank(1, constants.MAX_LINE_LENGTH)]"
        :label="$t('ticketNumberLine')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.ticketNumberStart"
        :rules="[rules.required, rules.positiveIntegerBetweenOrBlank(1, constants.MAX_LINE_LENGTH)]"
        :label="$t('ticketNumberStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.ticketNumberLength"
        :rules="[rules.required, rules.positiveIntegerBetweenOrBlank(1, constants.MAX_LINE_LENGTH)]"
        :label="$t('ticketNumberLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.settingLine"
        :rules="optionalFieldRules('setting', true, 1)"
        :label="$t('settingLine')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.settingStart"
        :rules="optionalFieldRules('setting', true, 1)"
        :label="$t('settingStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.settingLength"
        :rules="optionalFieldRules('setting', true, 1)"
        :label="$t('settingLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.tractLine"
        :rules="optionalFieldRules('tract', true, 1)"
        :label="$t('tractLine')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.tractStart"
        :rules="optionalFieldRules('tract', true, 1)"
        :label="$t('tractStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.tractLength"
        :rules="optionalFieldRules('tract', true, 1)"
        :label="$t('tractLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.destinationLine"
        :rules="optionalFieldRules('destination', true, 1)"
        :label="$t('destinationLine')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.destinationStart"
        :rules="optionalFieldRules('destination', true, 1)"
        :label="$t('destinationStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.destinationLength"
        :rules="optionalFieldRules('destination', true, 1)"
        :label="$t('destinationLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.contractAccountLine"
        :rules="optionalFieldRules('contractAccount', true, 1)"
        :label="$t('contractAccountLine')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.contractAccountStart"
        :rules="optionalFieldRules('contractAccount', true, 1)"
        :label="$t('contractAccountStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.contractAccountLength"
        :rules="optionalFieldRules('contractAccount', true, 1)"
        :label="$t('contractAccountLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.productLine"
        :rules="optionalFieldRules('product', true, 1)"
        :label="$t('productLine')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.productStart"
        :rules="optionalFieldRules('product', true, 1)"
        :label="$t('productStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.productLength"
        :rules="optionalFieldRules('product', true, 1)"
        :label="$t('productLengthSSP')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.weighedOutAtLine"
        :rules="optionalFieldRules('weighedOutAt', true, 1)"
        :label="$t('weighedOutAtLine')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.weighedOutAtStart"
        :rules="optionalFieldRules('weighedOutAt', true, 1)"
        :label="$t('weighedOutAtStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.weighedOutAtLength"
        :rules="optionalFieldRules('weighedOutAt', true, 1)"
        :label="$t('weighedOutAtLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.inWeightLine"
        :rules="optionalFieldRules('inWeight', true, 1)"
        :label="$t('inWeightLine')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.inWeightStart"
        :rules="optionalFieldRules('inWeight', true, 1)"
        :label="$t('inWeightStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.inWeightLength"
        :rules="optionalFieldRules('inWeight', true, 1)"
        :label="$t('inWeightLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.outWeightLine"
        :rules="optionalFieldRules('outWeight', true, 1)"
        :label="$t('outWeightLine')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.outWeightStart"
        :rules="optionalFieldRules('outWeight', true, 1)"
        :label="$t('outWeightStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.outWeightLength"
        :rules="optionalFieldRules('outWeight', true, 1)"
        :label="$t('outWeightLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.netWeightLine"
        :rules="[rules.required, rules.positiveIntegerBetweenOrBlank(1, constants.MAX_LINE_LENGTH)]"
        :label="$t('netWeightLine')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.netWeightStart"
        :rules="[rules.required, rules.positiveIntegerBetweenOrBlank(1, constants.MAX_LINE_LENGTH)]"
        :label="$t('netWeightStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.netWeightLength"
        :rules="[rules.required, rules.positiveIntegerBetweenOrBlank(1, constants.MAX_LINE_LENGTH)]"
        :label="$t('netWeightLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.trailerIdentifierLine"
        :rules="optionalFieldRules('trailerIdentifier', true, 1)"
        :label="$t('trailerIdentifierLine')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.trailerIdentifierStart"
        :rules="optionalFieldRules('trailerIdentifier', true, 1)"
        :label="$t('trailerIdentifierStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.trailerIdentifierLength"
        :rules="optionalFieldRules('trailerIdentifier', true, 1)"
        :label="$t('trailerIdentifierLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12">
      <v-row dense align="center">
        <v-col cols="auto">
          <span class="text-h6">
            {{ $t('log') }}
          </span>
        </v-col>
        <v-col cols="auto">
          <Icon
            icon="mdi-information-outline"
            iconColor="info"
            :tooltipText="$t('scaleSheetProfileLogTooltip')"
            :small="false"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.speciesStart"
        :rules="[rules.required, rules.positiveIntegerBetweenOrBlank(1, constants.MAX_LINE_LENGTH)]"
        :label="$t('speciesStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.speciesLength"
        :rules="[rules.required, rules.positiveIntegerBetweenOrBlank(1, constants.MAX_LINE_LENGTH)]"
        :label="$t('speciesLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.buttLogStart"
        :rules="[rules.required, rules.positiveIntegerBetweenOrBlank(1, constants.MAX_LINE_LENGTH)]"
        :label="$t('buttLogStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.buttLogLength"
        :rules="[rules.required, rules.positiveIntegerBetweenOrBlank(1, constants.MAX_LINE_LENGTH)]"
        :label="$t('buttLogLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12">
      <v-row dense align="center">
        <v-col cols="auto">
          <span class="subtitle-1">
            {{ $t('segmentOne') }}
          </span>
        </v-col>
        <v-col cols="auto">
          <Icon
            icon="mdi-information-outline"
            iconColor="info"
            :tooltipText="$t('segmentOneInfoTooltip')"
            :small="false"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneGradeStart"
        :rules="optionalFieldRules('segmentOneGrade', false, 1)"
        :label="$t('segmentOneGradeStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneGradeLength"
        :rules="optionalFieldRules('segmentOneGrade', false, 1)"
        :label="$t('segmentOneGradeLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneEndUseSortStart"
        :rules="optionalFieldRules('segmentOneEndUseSort', false, 1)"
        :label="$t('segmentOneEndUseSortStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneEndUseSortLength"
        :rules="optionalFieldRules('segmentOneEndUseSort', false, 1)"
        :label="$t('segmentOneEndUseSortLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneLengthStart"
        :rules="[rules.required, rules.positiveIntegerBetweenOrBlank(1, constants.MAX_LINE_LENGTH)]"
        :label="$t('segmentOneLengthStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneLengthLength"
        :rules="[rules.required, rules.positiveIntegerBetweenOrBlank(1, constants.MAX_LINE_LENGTH)]"
        :label="$t('segmentOneLengthLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneDiameterStart"
        :rules="[rules.required, rules.positiveIntegerBetweenOrBlank(1, constants.MAX_LINE_LENGTH)]"
        :label="$t('segmentOneDiameterStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneDiameterLength"
        :rules="[rules.required, rules.positiveIntegerBetweenOrBlank(1, constants.MAX_LINE_LENGTH)]"
        :label="$t('segmentOneDiameterLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneGrossVolumeStart"
        :rules="[segmentOneVolumeRules, optionalFieldRules('segmentOneNetVolume', false, 1)].flat()"
        :label="$t('segmentOneGrossVolumeStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneGrossVolumeLength"
        :rules="[segmentOneVolumeRules, optionalFieldRules('segmentOneNetVolume', false, 1)].flat()"
        :label="$t('segmentOneGrossVolumeLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneNetVolumeStart"
        :rules="[segmentOneVolumeRules, optionalFieldRules('segmentOneNetVolume', false, 1)].flat()"
        :label="$t('segmentOneNetVolumeStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneNetVolumeLength"
        :rules="[segmentOneVolumeRules, optionalFieldRules('segmentOneNetVolume', false, 1)].flat()"
        :label="$t('segmentOneNetVolumeLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneDefectVolumeStart"
        :rules="optionalFieldRules('segmentOneDefectVolume', false, 1)"
        :label="$t('segmentOneDefectVolumeStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentOneDefectVolumeLength"
        :rules="optionalFieldRules('segmentOneDefectVolume', false, 1)"
        :label="$t('segmentOneDefectVolumeLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12">
      <v-row dense align="center">
        <v-col cols="auto">
          <span class="subtitle-1">
            {{ $t('segmentTwo') }}
          </span>
        </v-col>
        <v-col cols="auto">
          <Icon
            icon="mdi-information-outline"
            iconColor="info"
            :tooltipText="$t('segmentTwoInfoTooltip')"
            :small="false"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoGradeStart"
        :rules="optionalFieldRules('segmentTwoGrade', false)"
        :label="$t('segmentTwoGradeStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoGradeLength"
        :rules="optionalFieldRules('segmentTwoGrade', false)"
        :label="$t('segmentTwoGradeLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoEndUseSortStart"
        :rules="optionalFieldRules('segmentTwoEndUseSort', false)"
        :label="$t('segmentTwoEndUseSortStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoEndUseSortLength"
        :rules="optionalFieldRules('segmentTwoEndUseSort', false)"
        :label="$t('segmentTwoEndUseSortLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoLengthStart"
        :rules="segmentTwoRules"
        :label="$t('segmentTwoLengthStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoLengthLength"
        :rules="segmentTwoRules"
        :label="$t('segmentTwoLengthLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoDiameterStart"
        :rules="segmentTwoRules"
        :label="$t('segmentTwoDiameterStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoDiameterLength"
        :rules="segmentTwoRules"
        :label="$t('segmentTwoDiameterLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoGrossVolumeStart"
        :label="$t('segmentTwoGrossVolumeStart')"
        :rules="[segmentTwoVolumeRules, optionalFieldRules('segmentTwoGrossVolume', false)].flat()"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoGrossVolumeLength"
        :label="$t('segmentTwoGrossVolumeLength')"
        :rules="[segmentTwoVolumeRules, optionalFieldRules('segmentTwoGrossVolume', false)].flat()"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoNetVolumeStart"
        :rules="[segmentTwoVolumeRules, optionalFieldRules('segmentTwoNetVolume', false)].flat()"
        :label="$t('segmentTwoNetVolumeStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoNetVolumeLength"
        :rules="[segmentTwoVolumeRules, optionalFieldRules('segmentTwoNetVolume', false)].flat()"
        :label="$t('segmentTwoNetVolumeLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoDefectVolumeStart"
        :rules="optionalFieldRules('segmentTwoDefectVolume', false)"
        :label="$t('segmentTwoDefectVolumeStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentTwoDefectVolumeLength"
        :rules="optionalFieldRules('segmentTwoDefectVolume', false)"
        :label="$t('segmentTwoDefectVolumeLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12">
      <v-row dense align="center">
        <v-col cols="auto">
          <span class="subtitle-1">
            {{ $t('segmentThree') }}
          </span>
        </v-col>
        <v-col cols="auto">
          <Icon
            icon="mdi-information-outline"
            iconColor="info"
            :tooltipText="$t('segmentThreeInfoTooltip')"
            :small="false"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentThreeLengthStart"
        :rules="segmentThreeRules"
        :label="$t('segmentThreeLengthStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentThreeLengthLength"
        :rules="segmentThreeRules"
        :label="$t('segmentThreeLengthLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentThreeDiameterStart"
        :rules="segmentThreeRules"
        :label="$t('segmentThreeDiameterStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentThreeDiameterLength"
        :rules="segmentThreeRules"
        :label="$t('segmentThreeDiameterLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentThreeGrossVolumeStart"
        :rules="[segmentThreeVolumeRules, optionalFieldRules('segmentThreeGrossVolume', false)].flat()"
        :label="$t('segmentThreeGrossVolumeStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentThreeGrossVolumeLength"
        :rules="[segmentThreeVolumeRules, optionalFieldRules('segmentThreeGrossVolume', false)].flat()"
        :label="$t('segmentThreeGrossVolumeLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentThreeNetVolumeStart"
        :rules="[segmentThreeVolumeRules, optionalFieldRules('segmentThreeNetVolume', false)].flat()"
        :label="$t('segmentThreeNetVolumeStart')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
    <v-col cols="12" md="6" lg="2">
      <v-text-field
        v-model="profile.segmentThreeNetVolumeLength"
        :rules="[segmentThreeVolumeRules, optionalFieldRules('segmentThreeNetVolume', false)].flat()"
        :label="$t('segmentThreeNetVolumeLength')"
        outlined
        maxLength="4"
        color="black"
      />
    </v-col>
  </v-row>
</template>

<script>
import fieldRules from '@/utils/rules.js'
export default {
  name: 'ScaleSheetImportFixedLengthProfileForm',
  props: {
    propProfile: {
      type: Object,
      required: true
    }
  },

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  data: () => ({
    rules: fieldRules.rules
  }),

  computed: {
    constants () {
      return {
        MAX_LINE_LENGTH: 1000,
        MAX_LENGTH: 4,
        TRAILER_IDENTIFIER_MAX_LENGTH: 10
      }
    },
    profile: {
      get () {
        return this.propProfile
      },
      set (value) {
        this.$emit('update', value)
      }
    },
    segmentOneVolumeRules () {
      return this.propProfile.segmentOneDiameterStart &&
        this.propProfile.segmentOneDiameterLength &&
        this.propProfile.segmentOneLengthStart &&
        this.propProfile.segmentOneLengthLength &&
        !this.propProfile.segmentOneGrossVolumeStart &&
        !this.propProfile.segmentOneGrossVolumeLength &&
        !this.propProfile.segmentOneNetVolumeStart &&
        !this.propProfile.segmentOneNetVolumeLength
        ? [this.rules.positiveInteger, this.rules.positiveIntegerBetweenOrBlank(1, this.constants.MAX_LINE_LENGTH)]
        : [this.rules.positiveIntegerBetweenOrBlank(1, this.constants.MAX_LINE_LENGTH)]
    },
    segmentTwoRules () {
      return this.propProfile.segmentTwoDiameterStart ||
        this.propProfile.segmentTwoDiameterLength ||
        this.propProfile.segmentTwoLengthStart ||
        this.propProfile.segmentTwoLengthLength ||
        this.propProfile.segmentTwoGrossVolumeStart ||
        this.propProfile.segmentTwoGrossVolumeLength ||
        this.propProfile.segmentTwoNetVolumeStart ||
        this.propProfile.segmentTwoNetVolumeLength
        ? [this.rules.positiveInteger, this.rules.positiveIntegerBetweenOrBlank(0, this.constants.MAX_LINE_LENGTH)]
        : [this.rules.positiveIntegerBetweenOrBlank(0, this.constants.MAX_LINE_LENGTH)]
    },
    segmentTwoVolumeRules () {
      return this.propProfile.segmentTwoDiameterStart &&
        this.propProfile.segmentTwoDiameterLength &&
        this.propProfile.segmentTwoLengthStart &&
        this.propProfile.segmentTwoLengthLength &&
        !this.propProfile.segmentTwoGrossVolumeStart &&
        !this.propProfile.segmentTwoGrossVolumeLength &&
        !this.propProfile.segmentTwoNetVolumeStart &&
        !this.propProfile.segmentTwoNetVolumeLength
        ? [this.rules.positiveInteger, this.rules.positiveIntegerBetweenOrBlank(0, this.constants.MAX_LINE_LENGTH)]
        : [this.rules.positiveIntegerBetweenOrBlank(0, this.constants.MAX_LINE_LENGTH)]
    },
    segmentThreeRules () {
      return this.propProfile.segmentThreeDiameterStart ||
        this.propProfile.segmentThreeDiameterLength ||
        this.propProfile.segmentThreeLengthStart ||
        this.propProfile.segmentThreeLengthLength ||
        this.propProfile.segmentThreeGrossVolumeStart ||
        this.propProfile.segmentThreeGrossVolumeLength ||
        this.propProfile.segmentThreeNetVolumeStart ||
        this.propProfile.segmentThreeNetVolumeLength
        ? [this.rules.positiveInteger, this.rules.positiveIntegerBetweenOrBlank(0, this.constants.MAX_LINE_LENGTH)]
        : [this.rules.positiveIntegerBetweenOrBlank(0, this.constants.MAX_LINE_LENGTH)]
    },
    segmentThreeVolumeRules () {
      return this.propProfile.segmentThreeDiameterStart &&
        this.propProfile.segmentThreeDiameterLength &&
        this.propProfile.segmentThreeLengthStart &&
        this.propProfile.segmentThreeLengthLength &&
        !this.propProfile.segmentThreeGrossVolumeStart &&
        !this.propProfile.segmentThreeGrossVolumeLength &&
        !this.propProfile.segmentThreeNetVolumeStart &&
        !this.propProfile.segmentThreeNetVolumeLength
        ? [this.rules.positiveInteger, this.rules.positiveIntegerBetweenOrBlank(0, this.constants.MAX_LINE_LENGTH)]
        : [this.rules.positiveIntegerBetweenOrBlank(0, this.constants.MAX_LINE_LENGTH)]
    }
  },
  methods: {
    optionalFieldRules (field, isHeader, lowerBound = 0) {
      return isHeader
        ? this.propProfile[field + 'Line'] ||
          this.propProfile[field + 'Start'] ||
          this.propProfile[field + 'Length']
          ? [this.rules.required, this.rules.positiveIntegerBetweenOrBlank(lowerBound, this.constants.MAX_LINE_LENGTH)]
          : [this.rules.positiveIntegerBetweenOrBlank(lowerBound, this.constants.MAX_LINE_LENGTH)]
        : this.propProfile[field + 'Start'] ||
          this.propProfile[field + 'Length']
          ? [this.rules.required, this.rules.positiveIntegerBetweenOrBlank(lowerBound, this.constants.MAX_LINE_LENGTH)]
          : [this.rules.positiveIntegerBetweenOrBlank(lowerBound, this.constants.MAX_LINE_LENGTH)]
    }
  }
}
</script>
